import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const ToolTipUsername = styled("div")`
    height: 2.5rem;
    color: ${({theme}) => theme.uxfabric.text.primary};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
`

export const ToolTipContent = styled("div")`
    width: 16rem;
    height: 9.125rem;
    border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogContent.default.backgroundColor};
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    text-transform: capitalize;
    text-align: center;

    @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape) {
        position: absolute;
        top: -3.75rem;
    }

    hr {
        border: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    }
`

export const TooltipHeader = styled("div")`
    height: 2.75rem;
`

export const TooltipFooter = styled("div")`
    height: 6.375rem;
    border-top: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.borderColor};
    background: ${({theme}) => theme.uxfabric.components.dialog.dialogActions.default.backgroundColor};
    border-radius: inherit;
    padding: 0 1rem 1rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const Divider = styled("hr")`
    margin: 0.5rem 0.8rem 0px;
`

export const ToolTipTitle = styled("span")`
    color: ${({theme}) => theme.uxfabric.text.primary};
    line-height: 1.5;
    letter-spacing: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.letterSpacing}px;
    padding-left: 0.6rem;
    font-size: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.fontSize};
    font-family: ${({theme}) =>
        `${theme.uxfabric.component.listItemSubtitle1.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-weight: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.fontWeight};
    text-transform: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.textTransform};
`

export const ViewAccountSummaryLink = styled("div")`
    padding: 0.8rem 0.75rem;
    display: flex;
    text-decoration: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    height: 2.75rem;
    && a {
        font-family: ${({theme}) => theme.uxfabric.component.listItemSubtitle1.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        position: initial;
        color: ${({theme}) => theme.uxfabric.text.primary};
        text-decoration: none;
        &:hover {
            color: ${({theme}) => theme.uxfabric.text.primary};
            text-decoration: underline;
        }
    }
`
export const SignoutButton = styled("div")`
    height: 2.25rem;
    letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
    font-family: ${({theme}) => theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
    font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    && a span {
        font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
    }
`
